

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import vSelect from "vue-select"

import SkeletonLoader from "@/components/SkeletonLoader.vue"
import DataTable from "../DataTable.vue"

import User from "@/types/user"
import apiRecordNameSettings from "@/services/api_RecordNameSettings"
import { RecordNameSettings } from "@/types/recordNameSettings"

import StringValidation from "@/scripts/stringValidation"

@Component({
	components: {
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"data-table": DataTable,
		"skeleton": SkeletonLoader
	}
})
export default class RecordNameSetup extends Vue {
	$refs!: {
		dataTable: DataTable
	}

	private loading: boolean = false;
	private recordNameSettings: RecordNameSettings[] = [];

	public async mounted () {
		await this.loadRecordNameSettings()
	}

	private get columns (): any[] {
		return [
			{ key: "title", label: "Title", sortable: true, errors: (item: any) => StringValidation.validateTitle(item.title) },
			{ key: "default", label: "Default", sortable: false, dataType: "checkbox" }
		]
	}

	private async loadRecordNameSettings () {
		this.loading = true
		this.recordNameSettings = await apiRecordNameSettings.recordNameSettingsList()
		this.loading = false
	}

	private createRecordNameSettings () {
		return { id: null, title: "", default: false }
	}

	private async saveRecordNameSettings (recordNameSettings: RecordNameSettings) {
		const currentRecordNameSetting = this.recordNameSettings.find(s => s.id === recordNameSettings.id)
		const currentRecordNameSettingWithDefault = this.recordNameSettings.find(s => s.default)

		// Add / update
		if (recordNameSettings.id === null || (currentRecordNameSetting && currentRecordNameSetting.title !== recordNameSettings.title)) {
			recordNameSettings.id = await apiRecordNameSettings.recordNameSettingsSave(recordNameSettings)
		}

		// Default
		if (recordNameSettings.default && recordNameSettings.id) {
			if ((currentRecordNameSettingWithDefault && currentRecordNameSettingWithDefault.id !== recordNameSettings.id) || currentRecordNameSettingWithDefault == null) {
				await apiRecordNameSettings.recordNameSettingsDefault(recordNameSettings)
			}
		}

		this.loadRecordNameSettings()
	}

	private async deleteRecordNameSetting (recordNameSettings: RecordNameSettings) {
		if (recordNameSettings.default === false && this.recordNameSettings.length > 1) {
			this.loading = true

			await apiRecordNameSettings.recordNameSettingsDelete(recordNameSettings)

			this.loadRecordNameSettings()
		}
	}
}
